const DatasetManagerConst = {
	RUN_ALL_CLICK: 'RUN_ALL_CLICK',
	SHOW_RUNALL_MSG: 'SHOW_RUNALL_MSG',
};

export default DatasetManagerConst;
